import React from "react";
import "./css/TextInput.css";

import { TextField, Label, Input } from "react-aria-components";

function TextInput(props) {
  const {
    label,
    size,
    type = "text",
    notice,
    width,
    edge,
    style,
    transparent,
    error,
  } = props;

  return (
    <TextField
      className={`text-input size-${size} edge-${edge} ${error && "error"}`}
      {...props}
    >
      {label && <Label className="label">{label}</Label>}
      {(error || notice) && (
        <span className={`status-message ${error ? "error" : "notice"}`}>
          {error || notice}
        </span>
      )}

      {type === "textarea" ? (
        <textarea
          className={"input-field text-area"}
          cols="20"
          rows="8"
          style={{
            ...style,
            background: transparent && "none",
            width: `${width}rem`,
          }}
        ></textarea>
      ) : (
        <Input
          className={"input-field"}
          style={{
            ...style,
            background: transparent && "none",
            width: `${width}rem`,
          }}
        />
      )}
    </TextField>
  );
}

export default TextInput;
